var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "camera-dialog" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拍摄照片",
            visible: _vm.dialogVisible,
            top: "5vh",
            width: "481px",
            "append-to-body": true,
            "close-on-click-modal": true,
            "before-close": _vm.dialogCancle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.dialogCancle,
          },
        },
        [
          _c("Camera", {
            attrs: { show: _vm.dialogVisible },
            on: {
              fileUploadSuccess: _vm.fileUploadSuccess,
              cameraAskFailure: _vm.dialogCancle,
            },
          }),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }